import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function emailDetailedValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const value = control.value;
        if (!value) return null;

        // Data for analysis
        const atSplit = value.split('@');
        const localPart = atSplit[0] || '';
        const domain = atSplit[1] || '';
        const domainSegments = domain.split('.');
        const domainExtention = extractExtension(value);
        const domainName = domainSegments[0] || '';
        const lastSegment = domainSegments[domainSegments.length - 1] || '';
        console.log(domainName);
        // Your specific final pattern
        const finalRegex = /^[a-zA-Z0-9._-]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}$/;

        switch (true) {
            // 1. Must not contain spaces
            case /\s/.test(value):
                return { 'emailError': "Please remove spaces from the email address." };

            // 2. Must contain user name
            case !localPart:
                return { 'emailError': "User name before (@) cannot be empty." };

            // 3. User name can't start or end with (.), (_), or (-)
            case /^[\.\-_]|[\.\-_]$/.test(localPart):
                return { 'emailError': "User name before (@) cann't start or end with (.), (_), or (-)." };

            // 4. Must match mail pattern
            case !(/^[a-zA-Z0-9._-]{1,}$/.test(localPart)):
                return { 'emailError': "User name before (@) must contain only (A-Z), (0-9), (.), (_), or (-)." };

            // 5. Must contain @ exactly once
            case atSplit.length === 1:
                return { 'emailError': "Missing '@' symbol." };

            // 6. Must contain @ 
            case atSplit.length > 2:
                return { 'emailError': "Email must contain only one '@' symbol." };

            // 7. Domain must contain at least one dot
            case !domainName:
                return { 'emailError': "Email must contain domain (e.g., gmail.com)." };

            // 8. Domain must contain at least one dot
            case domainName.length < 2:
                return { 'emailError': "Domain name must be at least 2 characters." };

            // 8. Domain must contain at least one dot
            case !(/^[a-zA-Z0-9.-]{2,}$/.test(domainName)):
                return { 'emailError': "Domain name must contain (A-Z), (0-9), (.), or (-)." };

            // 9. Domain must contain at least one dot
            case !domain.includes('.'):
                return { 'emailError': "Domain name must contain a dot (e.g., gmail.com)." };

            // 10. Domain extension (after the first dot in the domain) must not contain numbers
            case /[^a-zA-Z.]/.test(domainExtention):
                return { 'emailError': "Domain extension (e.g., .com) must contain only letters and dots." };

            // 11. Final segment (after the last dot) must be 2+ characters
            case lastSegment.length < 2:
                return { 'emailError': "The final part (e.g., .du) must be at least 2 characters." };

            // 12. Final Catch-all Check (using your provided Regex)
            case !finalRegex.test(value):
                return { 'emailError': "Email format is invalid. Please check for illegal characters." };

            default:
                return null; // All rules passed
        }
    };
}

function extractExtension(email: string): string | null {
    // This regex looks for the first dot after the @ and grabs everything after it
    const regex = /@.*?\.(.*)$/;
    const match = email.match(regex);
    return match ? match[1] : null;
}

